import {
    DatasourceActions,
    DatasourceActionTypes,
    DatasourceState,
} from "#store/datasources/datasourceTypes";
import {
    DoneState,
    ErrorState,
    FetchingState,
    InitializedState,
    IoStateEnum,
} from "#store/types";
import { DatasourceDto } from "#services/pilotService/types";

const initialState: DatasourceState = {
    data: {
        state: IoStateEnum.initialized,
        error: null,
        payload: null,
        timestamp: new Date(),
    } as InitializedState,
};

/** reducer */
export function datasourceReducer(
    state = initialState,
    action: DatasourceActions
): DatasourceState {
    switch (action.type) {
        case DatasourceActionTypes.LOAD_SUCCESS: {
            return {
                data: {
                    payload: action.payload,
                    state: IoStateEnum.done,
                    error: null,
                    timestamp: new Date(),
                } as DoneState<DatasourceDto[]>,
            };
        }
        case DatasourceActionTypes.LOAD_ERROR: {
            return {
                data: {
                    payload: null,
                    error: undefined,
                    state: IoStateEnum.error,
                    timestamp: new Date(),
                } as ErrorState,
            };
        }
        case DatasourceActionTypes.LOAD_START: {
            return {
                data: {
                    payload: null,
                    error: null,
                    state: IoStateEnum.fetching,
                    timestamp: new Date(),
                } as FetchingState,
            };
        }
        default:
            return state;
    }
}
